import React, {  useEffect, useState } from "react";
import { handleScroll, onTableRowClick, onTableRowMouseOver } from "./TablePanelsVM";
import { v4 as uuidv4 } from "uuid"
import { TableRow, Table, TableHead, TableCell, TableBody, TablePagination, TableContainer, Paper } from "@mui/material";
const TableMui = ({ view, table, activeWidget,page,rowsPerPage }) => {

  const [visible, setVisible] = useState(false);
  const [sortArrow, setSortArrow] = useState(['', 'default'])
  const [sortTerm, setSortTerm] = useState()
  const [sortName, setSortName] = useState('')
  const [sortField, setSortField] = useState('')
  const [selectedRow, setSelectedRow] = useState(null)


  useEffect(() => {
    if (activeWidget === table?.layerName) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget,table]);

  if (table?.layerName) {

    let fieldNames = []

    const { layerName, layerId, fields, popupFields, features } = table

    const handleSortedItems = (e, name) => {
      setSortTerm(e)
      if (!sortName || (e !== sortName && e + 'Alt' !== sortName)) {
        setSortArrow([e, 'down'])
        setSortName(e + 'Alt')
      } else if (sortName === e + 'Alt') {
        setSortArrow([e, 'up'])
        setSortName(e)
      } else {
        setSortArrow([e, 'default'])
        setSortName('')
      }
      setSortField(name)
    }
    fieldNames = popupFields.map((column, index) => {
      return (
        <TableCell key={index}
          align={column.align}
          onClick={e => handleSortedItems(index, column?.name)}>
          <div className="table__head__cell" style={{ textAlign: column?.name }}>
            {column?.name === 'left' ?
              <>
                <span>{column?.label}</span>
                <span style={{ padding: '0 .5rem', flex: '1', width: '1.5rem' }}>
                  {(index === sortArrow[0] ? (sortArrow[1] === 'down' ? '▼' : sortArrow[1] === 'up' ? "▲" : '▶') : '▶')}
                </span>
              </>
              :
              <>
                <span>{column?.label}</span>
                <span style={{ padding: '0 .5rem', flex: '1', width: '1.5rem' }}>
                  {(index === sortArrow[0] ? (sortArrow[1] === 'down' ? '▼' : sortArrow[1] === 'up' ? "▲" : '▶') : '▶')}
                </span>
              </>}
          </div>

        </TableCell>
      );
    });

    let newFeatureList = [...features]

    if (sortArrow[1] === 'up') {
      newFeatureList.sort((a, b) => {
        if (a.attributes[sortField] < b.attributes[sortField]) {
          return 1;
        }
        if (a.attributes[sortField] > b.attributes[sortField]) {
          return -1;
        }
        return 0;
      });      
    } else if (sortArrow[1] === 'down') {
      newFeatureList.sort((a, b) => {
        if (a.attributes[sortField] > b.attributes[sortField]) {
          return 1;
        }
        if (a.attributes[sortField] < b.attributes[sortField]) {
          return -1;
        }
          return 0;
      });
      

    } else if (sortArrow[1] === 'default') {
      newFeatureList = features;
    }

    const lyr =view.map.allLayers.find((layer)=>layer.id===layerId)
    const subTypeField = lyr.typeIdField
    const types=lyr.types
    const tableRowData = newFeatureList
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    .map((feature) => {
      let data = [];

      const setSelectRow = (feature) => {
        setSelectedRow(feature);
      }

      const onRowClick = (view, feature) => {
        onTableRowClick(view,feature);
        setSelectRow(feature);
      }

      popupFields.forEach((field) => {
        if (field.type === "date") {
          let dat = feature.attributes[field.name]!==null?new Date(feature.attributes[field.name]).toDateString():""
          data.push(
            <TableCell
            sx={{ width: 100, wordWrap: 'break-word', whiteSpace: 'normal' }}
              className="table__cell"
              key={feature.attributes["OBJECTID"] + field.name}
            >
              {dat}
            </TableCell>
          );

        } else {
          let value = feature.attributes[field.name]
          if (field.name===subTypeField){
            const type = types.filter(type=>type.id===feature.attributes[field.name])
            if(type.length){
              value=type[0]['name']
            }
            
          }
          if(field.domain){
            field.domain.codedValues.forEach((item)=>{
              if(feature.attributes[field.name]===item.code){
                value=item.name
              }
            })
          }
          if(subTypeField){
            if(!field.domain && field.name!==subTypeField){
              types.forEach(type=>{
                if(feature.attributes[subTypeField]===type.id){
                  if(type.domains){
                    if(type.domains[field.name]){
                      type.domains[field.name].codedValues.forEach(code=>{
                        if(code.code===feature.attributes[field.name]){
                          value=code.name
                        }
                      })
                    }

                  }

                }
              })
            }
          }
          data.push(
            <TableCell
            sx={{ width: 100, wordWrap: 'break-word', whiteSpace: 'normal' }}
              className="table__cell"
              key={feature.attributes["OBJECTID"] + field.name}
            >
              {value}
            </TableCell>
          );
        }
      });

      return (
        <TableRow
          key={uuidv4()}
          className= {(selectedRow === feature ? 'table__row--selected td' : 'table__row')}
          onMouseOver={() => {
            onTableRowMouseOver(feature, layerName);
          }}
          onClick={(event) => {
            onRowClick(view,feature);
            handleScroll(event);
          }}
        >
          {data}
        </TableRow>
      );

    });

    let style = { display: "block" };
    if (visible) {
      style.display = "block";
    } else {
      style.display = "none";
    }


    return (
      <div style={style}>
      <Table 
       className="table"

        >
        <TableHead className="table__head">
          <TableRow className="table__head__row">{fieldNames}</TableRow>
        </TableHead>
        <TableBody className="table__body">{tableRowData}
        </TableBody>
      </Table>
      </div>

    );
  } else {
    return <React.Fragment></React.Fragment>;
  }

};

export default TableMui;






















